<template>
  <div class="two-column-sidebar">
    <!-- 音频元素，动态 src -->
    <audio id="notification-sound" :src="audioSrc" preload="auto"></audio>
    <!-- 第一列：主导航 -->
    <div class="main-nav">
      <div 
        v-for="(item, index) in routes" 
        :key="index"
        class="nav-item"
        :class="{ active: activeMainNav === item.name }"
        @click="handleMainNavClick(item)"
      >
        <div class="icon-container">
          <img v-if="getNavIcon(item.name)" :src="getNavIcon(item.name)" :alt="item.name" class="nav-icon" />
          <span v-else>{{ getIconText(item.name) }}</span>
        </div>
        <span>{{ item.meta?.title || item.name }}</span>
        <div class="red-dot" v-if="redDot[item.name]"></div>
      </div>
    </div>
    
    <!-- 第二列：子导航或内容 - 只在设置页面显示 -->
    <div class="sub-nav" v-if="activeMainNav === 'Settings'">
      <!-- 设置的二级导航 -->
      <div class="sub-nav-header">设置</div>
      
      <!-- 有子导航的主导航项 -->
      <div v-for="(mainItem, mainIndex) in settingsMainItems" :key="mainIndex">
        <!-- 主导航标题 -->
        <div 
          class="main-nav-item"
          :class="{ active: (activeSettingsMainNav === mainItem.name && mainItem.children.length == 0) }"
          @click="handleSettingsMainNavClick(mainItem)"
        >
          <span>{{ mainItem.title }}</span>
          <i class="el-icon-arrow-right" v-if="mainItem.children && mainItem.children.length > 0"></i>
        </div>
        
        <!-- 子导航列表 -->
        <div 
          v-if="mainItem.children && mainItem.children.length > 0 && activeSettingsMainNav === mainItem.name"
          class="sub-nav-list"
        >
          <div 
            v-for="(subItem, subIndex) in mainItem.children" 
            :key="subIndex"
            class="sub-nav-item"
            :class="{ active: activeSubNav === subItem.name }"
            @click.stop="handleSubNavClick(subItem, mainItem)"
          >
            <span>|-- {{ subItem.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 财务 -->
    <div class="finance-nav" v-if="activeMainNav === 'Finance'">
      <!-- 设置的二级导航 -->
      <div class="sub-nav-header">财务</div>

       <!-- 有子导航的主导航项 -->
       <div v-for="(mainItem, mainIndex) in financeMainItems" :key="mainIndex">
        <!-- 主导航标题 -->
        <div class="main-nav-item"
          :class="{ active: (activeFinanceMainNav === mainItem.name && mainItem.children.length == 0) }"
          @click="handleFinanceMainNavClick(mainItem)"
        >
          <span>{{ mainItem.title }}</span>
          <i class="el-icon-arrow-right" v-if="mainItem.children && mainItem.children.length > 0"></i>
        </div>
        
        <!-- 子导航列表 -->
        <div v-if="mainItem.children && mainItem.children.length > 0 && activeSettingsMainNav === mainItem.name"
          class="sub-nav-list">
          <div 
            v-for="(subItem, subIndex) in mainItem.children" 
            :key="subIndex"
            class="sub-nav-item"
            :class="{ active: activeSubNav === subItem.name }"
            @click.stop="handleSubNavClick(subItem, mainItem)"
          >
            <span>|-- {{ subItem.title }}</span>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { constantRoutes } from '@/router'
import eventBus from '@/utils/eventBus'
import req from '@/utils/req'

import dashboardIcon from '/img/icon_dashboard.png' // 仪表盘图标
import chatIcon from '/img/icon_chat.png' // 对话图标
import analyticsIcon from '/img/icon_analytics.png' // 数据分析图标
import webpageIcon from '/img/icon_wy.png' // 网页图标
import weworkIcon from '/img/icon_wework.png' // 企业微信图标
import wechatIcon from '/img/icon_wechat.png' // 微信图标
import douyinIcon from '/img/icon_douyin.png' // 抖音图标
import xiaohongshuIcon from '/img/icon_xiaohongshu.png' // 小红书图标
import kuaishouIcon from '/img/icon_kuaishou.png' // 快手图标
import meituanIcon from '/img/icon_meituan.png' // 美团图标
import marketingIcon from '/img/icon_marketing.png' // 营销图标
import customersIcon from '/img/icon_customers.png' // 新的客户图标
import aiserviceIcon from '/img/icon_aiservice.png' // AI服务图标
import statisticsIcon from '/img/icon_statistics.png' // 统计图标
import settingsIcon from '/img/icon_settings.png' // 设置图标
import testIcon from '/img/icon_test.png' // 测试图标
import financeIcon from '/img/icon_finance.png' // 财务图标

export default {
  name: 'TwoColumnSidebar',
  data() {
    return {
      activeMainNav: '',
      activeSettingsMainNav: '',
      activeSubNav: '',
      audioSrc: '/sounds/newmsg2.mp3',  // 音频源路径
      // 尝试不同的音频方法
      soundMethods: {
        browser: true,  // 浏览器方法
        electron: true  // Electron方法
      },
      // 设置模块的主导航项
      settingsMainItems: [
        // { 
        //   name: 'WeWorkSettings', 
        //   title: '企业微信', 
        //   path: 'wework',
        //   children: [
        //     { name: 'WeWorkConfig', title: '基础配置', path: 'config' },
        //     { name: 'WeWorkAccount', title: '账号管理', path: 'account' },
        //     { name: 'WeWorkDepartment', title: '部门管理', path: 'department' },
        //     { name: 'WeWorkTag', title: '标签管理', path: 'tag' },
        //     { name: 'WeWorkMessage', title: '消息管理', path: 'message' },
        //     { name: 'WeWorkMoments', title: '朋友圈', path: 'moments' },
        //     { name: 'WeWorkMaterial', title: '素材库', path: 'material' },
        //     { name: 'WeWorkAutomation', title: '自动化', path: 'automation' },
        //     { name: 'WeWorkAnalytics', title: '数据分析', path: 'analytics' },
        //     { name: 'WeWorkGroup', title: '群管理', path: 'group' },
        //     { name: 'WeWorkCustomer', title: '客户管理', path: 'customer' },
        //     { name: 'WeWorkBroadcast', title: '群发助手', path: 'broadcast' },
        //     { name: 'WeWorkChatArchive', title: '会话存档', path: 'chatarchive' }
        //   ]
        // },
        {
          name: 'BaseSettings',
          title: '基础设置',
          path: 'baseset',
          children: [
                { name: 'PersonalQuestionSettings', title: '个人问题', path: 'personalquestion' },
                { name: 'CommonQuestionSettings', title: '常见问题', path: 'commonquestion' },
                { name: 'AiKnowledgeBaseSettings', title: 'AI知识库', path: 'aiknowledgebase' },
                { name: 'AutoReplySettings', title: '自动回复', path: 'autoreply' },
          ]
        },
        {
          name: 'BindingSettings',
          title: '绑定设置',
          path: 'binding',
          children: [
                { name: 'WechatBinding', title: '微信', path: 'wechat' },
                { name: 'WebSiteBinding', title: '网站', path: 'website' },
                { name: 'KuaishouBinding', title: '快手', path: 'kuaishou' },
                { name: 'WeiboBinding', title: '微博', path: 'weibo' },
                // { name: 'DouyinBinding', title: '抖音', path: 'douyin' },
                // { name: 'XiaohongshuBinding', title: '小红书', path: 'xiaohongshu' },
                // { name: 'KuaishouBinding', title: '快手', path: 'kuaishou' },
                // { name: 'MeituanBinding', title: '美团', path: 'meituan' }    
          ]
        },
        // {
        //   name: 'ChatSettings',
        //   title: '对话设置',
        //   path: 'chat',
        //   children: [
        //     { name: 'ServiceAllocation', title: '客服分配', path: 'allocation' }
        //   ]
        // },
        // {
        //   name: 'CustomerSettings',
        //   title: '客资设置',
        //   path: 'customer',
        //   children: [
        //     { name: 'CustomerTags', title: '标签', path: 'tags' },
        //     { name: 'CustomerNotification', title: '推送通知', path: 'notification' },
        //     { name: 'CustomerRules', title: '保存规则', path: 'rules' },
        //     { name: 'CustomerSources', title: '自定义来源', path: 'sources' },
        //     { name: 'CustomerBlacklist', title: '黑名单', path: 'blacklist' },
        //     { name: 'PhoneCheck', title: '空号检测', path: 'phonecheck' }
        //   ]
        // },
        // 只有主导航的项目
        { name: 'ServiceSettings', title: '客服管理', path: 'service', children: []},
        // { name: 'MobileSettings', title: '手机值班', path: 'mobile' },
        // { name: 'NotificationSettings', title: '通知设置', path: 'notification' },
        // { name: 'ClientSettings', title: '客户端设置', path: 'client' },
        // { name: 'PaymentSettings', title: '充值续费', path: 'payment' },
        { name: 'WechatSettings', title: '微信设置', path: 'wechat' },
        // { name: 'SystemSettings', title: '系统设置', path: 'system' }
      ],

      set_base: {
        name: 'BaseSettings',
          title: '基础设置',
          path: 'baseset',
          children: [
                { name: 'PersonalQuestionSettings', title: '个人问题', path: 'personalquestion' },
                { name: 'CommonQuestionSettings', title: '常见问题', path: 'commonquestion' },
                { name: 'AiKnowledgeBaseSettings', title: 'AI知识库', path: 'aiknowledgebase' },
                { name: 'AutoReplySettings', title: '自动回复', path: 'autoreply' },
          ]
      },

      set_binding: {
        name: 'BindingSettings',
        title: '绑定设置',
        path: 'binding',
        children: [
          { name: 'WechatBinding', title: '微信', path: 'wechat' },
          { name: 'WebSiteBinding', title: '网站', path: 'website' },
          { name: 'KuaishouBinding', title: '快手', path: 'kuaishou' },
          { name: 'WeiboBinding', title: '微博', path: 'weibo' }
          // { name: 'DouyinBinding', title: '抖音', path: 'douyin' },
          // { name: 'XiaohongshuBinding', title: '小红书', path: 'xiaohongshu' },
          // { name: 'MeituanBinding', title: '美团', path: 'meituan' },
        ]
      },

      set_service: { name: 'ServiceSettings', title: '客服管理', path: 'service', children: []},


      // 关于财务的导航
      activeFinanceMainNav: '',
      financeMainItems: [
        {
          name: 'ReceivePayment',
          title: '收款列表',
          path: 'receivepayment',
          children: []
        },
      ],

      navIcons: {
        Dashboard: dashboardIcon, // 仪表盘
        Chat: chatIcon, // 对话
        Customers: customersIcon, // 客户
        Analytics: analyticsIcon, // 数据分析
        Settings: settingsIcon, // 设置
        Webpage: webpageIcon, // 网页
        WeWork: weworkIcon, // 企业微信
        Wechat: wechatIcon, // 微信
        Douyin: douyinIcon, // 抖音
        Xiaohongshu: xiaohongshuIcon, // 小红书
        Kuaishou: kuaishouIcon, // 快手
        Meituan: meituanIcon, // 美团
        Marketing: marketingIcon, // 营销
        AIService: aiserviceIcon, // AI服务
        Statistics: statisticsIcon, // 统计
        Test: testIcon, // 测试
        Finance: financeIcon, // 财务
      },

      redDot: {
        Chat: false,
      }
    }
  },
  computed: {
    // 获取主路由
    routes() {
      // 从路由配置中获取主导航项
      const mainRoutes = constantRoutes.find(route => route.path === '/')
      let mainRoutes1 = mainRoutes ? mainRoutes.children.filter(route => !route.hidden) : []
      return mainRoutes1
    }
  },
  created() {
    // 初始化选中状态
    this.initActiveNav()
    this.registerNotification()
  },
  destroyed() {
    eventBus.off('notification_chat')
    eventBus.off('knetwork_status_change')
  },
  watch: {
    // 监听路由变化，更新导航选中状态
    '$route'() {
      this.initActiveNav()
    }
  },
  methods: {
    initActiveNav() {
      // 根据当前路由设置初始选中状态
      const path = this.$route.path
      const pathParts = path.split('/').filter(Boolean)
      // 根据权限设置路由
      this.reloadAuthRouter()
      if (pathParts.length > 0) {
        // 设置主导航选中状态
        const mainRoute = this.routes.find(route => route.path === pathParts[0])
        if (mainRoute) {
          this.activeMainNav = mainRoute.name
          
          // 如果是设置模块，还需要设置子导航选中状态
          if (mainRoute.name === 'Settings' && pathParts.length > 1) {
            // 查找对应的设置主导航
            const settingsMainItem = this.settingsMainItems.find(item => {
              // 检查路径是否匹配
              if (item.path === pathParts[1]) return true
              // 检查子项是否匹配
              if (item.children) {
                return item.children.some(child => 
                  pathParts.length > 2 && child.path === pathParts[2] && item.path === pathParts[1]
                )
              }
              return false
            })
            
            if (settingsMainItem) {
              this.activeSettingsMainNav = settingsMainItem.name
              
              // 如果有子导航，查找对应的子导航
              if (settingsMainItem.children && settingsMainItem.children.length > 0 && pathParts.length > 2) {
                const subItem = settingsMainItem.children.find(item => item.path === pathParts[2])
                if (subItem) {
                  this.activeSubNav = subItem.name
                }
              }
            }
          }
        }
      } else {
        // 默认选中第一个导航
        if (this.routes.length > 0) {
          this.activeMainNav = this.routes[0].name
        }
      }
    },

    reloadAuthRouter() {
      let userinfo = localStorage.getItem("k_userInfo")
      userinfo = JSON.parse(userinfo)
      this.settingsMainItems = []
      if (userinfo.level != 'super_manager' && userinfo.level != 'manager') {
        this.set_base.children = [
          { name: 'CommonQuestionSettings', title: '常见问题', path: 'commonquestion' },
          { name: 'AiKnowledgeBaseSettings', title: 'AI知识库', path: 'aiknowledgebase' },
          { name: 'AutoReplySettings', title: '自动回复', path: 'autoreply' },
        ]
        this.settingsMainItems.push(this.set_base)
        return
      }

      this.settingsMainItems = [
        this.set_base, this.set_binding, this.set_service
      ]

    },
    
    handleMainNavClick(item) {
      this.redDot[item.name] = false
      this.activeMainNav = item.name
      console.log('点击导航项:', item.name, this.activeMainNav)

      if (item.name === 'Settings') {
        // 如果点击的是设置，跳转到设置页面
        // console.log('跳转到设置页面')
        // 默认选中第一个设置主导航
        if (this.settingsMainItems.length > 0) {
          const firstMainItem = this.settingsMainItems[0]
          this.activeSettingsMainNav = firstMainItem.name
          
          // 如果有子导航，默认选中第一个子导航
          if (firstMainItem.children && firstMainItem.children.length > 0) {
            const firstSubItem = firstMainItem.children[0]
            this.activeSubNav = firstSubItem.name
            try {
              // console.log('跳转到路径:', `/settings/${firstMainItem.path}/${firstSubItem.path}`)
              this.$router.push(`/settings/${firstMainItem.path}/${firstSubItem.path}`)
            } catch (error) {
              // console.error('路由跳转错误:', error)
            }
          } else {
            // 没有子导航，直接跳转到主导航
            try {
              // console.log('跳转到路径:', `/settings/${firstMainItem.path}`)
              this.$router.push(`/settings/${firstMainItem.path}`)
            } catch (error) {
              // console.error('路由跳转错误:', error)
            }
          }
        }
        return
      } 


      if (item.name === 'Finance') {
        // 如果点击的是财务，跳转到财务页面
        if (this.financeMainItems.length > 0) {
          const firstMainItem = this.financeMainItems[0]
          this.activeFinanceMainNav = firstMainItem.name
          
          // 如果有子导航，默认选中第一个子导航
          if (firstMainItem.children && firstMainItem.children.length > 0) {
            const firstSubItem = firstMainItem.children[0]
            this.activeSubNav = firstSubItem.name
            try {
              // console.log('跳转到路径:', `/settings/${firstMainItem.path}/${firstSubItem.path}`)
              this.$router.push(`/finance/${firstMainItem.path}/${firstSubItem.path}`)
            } catch (error) {
              // console.error('路由跳转错误:', error)
            }
          } else {
            // 没有子导航，直接跳转到主导航
            try {
              // console.log('跳转到路径:', `/settings/${firstMainItem.path}`)
              this.$router.push(`/finance/${firstMainItem.path}`)
            } catch (error) {
              // console.error('路由跳转错误:', error)
            }
          }
        }
        return
      }

        // 其他导航直接跳转
        try {
          // console.log('跳转到路径:', `/${item.path}`)
          this.$router.push(`/${item.path}`)
        } catch (error) {
          // console.error('路由跳转错误:', error)
        }
      
    },
    
    handleSettingsMainNavClick(item) {
      // console.log('点击设置主导航:', item.name, item.path)
      this.activeSettingsMainNav = item.name
      
      // 如果有子导航，默认选中第一个子导航
      if (item.children && item.children.length > 0) {
        const firstSubItem = item.children[0]
        this.activeSubNav = firstSubItem.name
        try {
          // console.log('跳转到路径:', `/settings/${item.path}/${firstSubItem.path}`)
          this.$router.push(`/settings/${item.path}/${firstSubItem.path}`)
        } catch (error) {
          // console.error('路由跳转错误:', error)
        }
      } else {
        // 没有子导航，直接跳转到主导航
        try {
          // console.log('跳转到路径:', `/settings/${item.path}`)
          this.$router.push(`/settings/${item.path}`)
        } catch (error) {
          // console.error('路由跳转错误:', error)
        }
      }
    },


    handleFinanceMainNavClick(item) {
      // console.log('点击财务主导航:', item.name, item.path)
      this.activeFinanceMainNav = item.name
      
      // 如果有子导航，默认选中第一个子导航
      if (item.children && item.children.length > 0) {
        const firstSubItem = item.children[0]
        this.activeSubNav = firstSubItem.name
        try {
          // console.log('跳转到路径:', `/settings/${item.path}/${firstSubItem.path}`)
          this.$router.push(`/finance/${item.path}/${firstSubItem.path}`)
        } catch (error) {
          // console.error('路由跳转错误:', error)
        }
      } else {
        // 没有子导航，直接跳转到主导航
        try {
          // console.log('跳转到路径:', `/settings/${item.path}`)
          this.$router.push(`/finance/${item.path}`)
        } catch (error) {
          // console.error('路由跳转错误:', error)
        }
      }
    },
    
    handleSubNavClick(subItem, mainItem) {
      // console.log('点击子导航:', subItem.name, subItem.path)
      this.activeSubNav = subItem.name
      try {
        // console.log('跳转到路径:', `/settings/${mainItem.path}/${subItem.path}`)
        this.$router.push(`/settings/${mainItem.path}/${subItem.path}`)
      } catch (error) {
        // console.error('路由跳转错误:', error)
      }
    },
    
    getIconText(name) {
      // 如果没有图标，则显示首字母
      return name.charAt(0);
    },
    
    getNavIcon(name) {
      return this.navIcons[name] || '';
    },

    setAudioSource() {
      // 在Electron环境使用file://协议
      if (window.electron) {
        this.audioSrc = 'file://' + window.electron.getAppPath() + '/sounds/newmsg2.mp3'
      } else {
        // 浏览器环境使用相对路径
        this.audioSrc = '/sounds/newmsg2.mp3'
      }
    },

    // 提示有未读消息
    alertUnreadMessage() {
      this.redDot['Chat'] = true
      // 播放提示音
      this.playNotificationSound()
    },
    // 注册消息通知
    registerNotification() {
      eventBus.on('notification_chat', (data) => {
        this.alertUnreadMessage()
      })

      eventBus.on('knetwork_status_change', (data) => {
        if (data) {
          this.reqUnreadCount()
        }
      })
    },

    reqUnreadCount() {
      req.request({
        url: '/Data/kefu_unread_count',
        method: 'post',
        data: {}
      }).then((res) => {
        if (res.data && res.data > 0) {
            this.alertUnreadMessage()
          }
      }).catch((err) => {})
    }, 

    playNotificationSound() {      
      // 对于Electron环境，尝试使用node.js的方式加载资源
      if (this.isElectronEnv()) {
        this.playAudioInElectron();
        return;
      }
      
      // 浏览器环境下尝试播放
      this.playAudioInBrowser();
    },
    
    isElectronEnv() {
      // 检测是否在Electron环境中
      return window.navigator.userAgent.toLowerCase().indexOf('electron') > -1;
    },
    
    playAudioInElectron() {
      try {
        console.log('在Electron环境中播放音频');
        // 1. 尝试从主进程获取路径
        if (window.electron && window.electron.getResourcePath) {
          const path = window.electron.getResourcePath('sounds/newmsg2.mp3');
          this.playAudioWithPath(path);
          return;
        }
        
        // 2. 尝试使用app.getAppPath()
        if (window.electron && window.electron.getAppPath) {
          const appPath = window.electron.getAppPath();
          const path = appPath + '/sounds/newmsg2.mp3';
          this.playAudioWithPath(path);
          return;
        }
        
        // 3. 尝试请求主进程播放
        if (window.electron && window.electron.ipcRenderer) {
          window.electron.ipcRenderer.send('play-notification-sound');
          return;
        }
        
        // 4. 降级到普通浏览器方法
        this.playAudioInBrowser();
      } catch (error) {
        this.playAudioInBrowser();
      }
    },
    
    playAudioInBrowser() {
      try {
        // 组织不同可能的路径
        const possiblePaths = [
          // 绝对路径从根目录
          '/sounds/newmsg2.mp3',
          // 相对于当前位置
          './sounds/newmsg2.mp3',
          // 相对于assets目录
          './assets/sounds/newmsg2.mp3',
          // 相对于public目录  
          './public/sounds/newmsg2.mp3',
          '/public/sounds/newmsg2.mp3',
          // 直接指定文件名
          'newmsg2.mp3'
        ];
        
        console.log('尝试以下路径3:', possiblePaths);
        
        // 逐个尝试路径
        let success = false;
        for (const path of possiblePaths) {
          if (success) break;
          
          try {
            this.playAudioWithPath(path);
            success = true;
          } catch (e) {
            console.log(`路径 ${path} 失败:`, e);
          }
        }
        
        if (!success) {
          console.error('所有路径均播放失败');
        }
      } catch (error) {
        console.error('浏览器播放错误:', error);
      }
    },
    
    playAudioWithPath(path) {
      // 创建音频元素并播放
      const audio = new Audio(path);
      
      // 添加事件监听
      audio.addEventListener('canplaythrough', () => {
        console.log(`音频已加载，准备播放: ${path}`);
        audio.play()
          .then(() => console.log('播放成功'))
          .catch(err => console.error('播放失败:', err));
      });
      
      audio.addEventListener('error', (e) => {
        console.error(`音频加载失败: ${path}`, e);
      });
      
      // 设置音频源并开始加载
      audio.src = path;
      audio.load();
    },
  }
}
</script>

<style scoped>
.two-column-sidebar {
  height: 100%;
  overflow: hidden;
  display: flex;
  width: auto; /* 改为自适应宽度 */
  flex-shrink: 0;
}

.first-column, .second-column {
  height: 100%;
  overflow-y: auto;
}

.main-nav {
  width: 80px;
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;
  min-height: 100vh;
  flex-shrink: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.nav-item {
  padding: 10px 0;
  text-align: center;
  color: #333; /* 恢复深色文字 */
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  position: relative;
}

.nav-item.active {
  color: #fff;
  background-color: #1890ff;
}

.icon-container {
  margin-bottom: 4px;
  font-size: 20px; /* 调整图标大小 */
}

.sub-nav {
  width: 200px;
  background-color: #f2f2f2;
  border-right: 1px solid #e8e8e8;
  height: 100%;
  overflow-y: auto;
  min-height: 100vh;
  flex-shrink: 0;
}

.sub-nav-header {
  padding: 16px;
  font-weight: bold;
  border-bottom: 1px solid #e8e8e8;
  color: #333; /* 恢复深色文字 */
}

.main-nav-item {
  padding: 12px 16px;
  color: #333; /* 恢复深色文字 */
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
}

.main-nav-item.active {
  color: #1890ff;
  background-color: #e6f7ff; /* 恢复浅蓝色背景 */
}

.sub-nav-list {
  background-color: #fafafa; /* 恢复浅灰色背景 */
}

.sub-nav-item {
  padding: 10px 16px 10px 32px;
  color: #333; /* 恢复深色文字 */
  cursor: pointer;
  position: relative;
}

.sub-nav-item.active {
  color: #1890ff;
  background-color: #e6f7ff; /* 恢复浅蓝色背景 */
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.red-dot {
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.test-sound-btn {
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 9999;
  padding: 5px 10px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.finance-nav {
  width: 200px;
  background-color: #f2f2f2;
  border-right: 1px solid #e8e8e8;
  height: 100%;
  overflow-y: auto;
  min-height: 100vh;
  flex-shrink: 0;
}



</style> 